import { render, staticRenderFns } from "./slip.vue?vue&type=template&id=39c93ba5&scoped=true&"
import script from "./slip.vue?vue&type=script&lang=js&"
export * from "./slip.vue?vue&type=script&lang=js&"
import style0 from "./slip.vue?vue&type=style&index=0&id=39c93ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c93ba5",
  null
  
)

export default component.exports